import { ref, computed } from 'vue'


export interface Dataset {
  id?: number
  name: string,
  date_series: Array<Date>,
  [key: string]: string | number | object | string[] | null | undefined
}

export function useDatasets(site_name: string) {
  const datasets = ref<Dataset[]>([]) // items is now Ref<Item[]>
  const getDatasets = async (): Promise<Dataset[]> => {
    const response = await fetch('/api/psi-dataset-by-site/' + site_name + '/?format=json')
    // Assert the response is OK
    if (!response.ok) {
      throw new Error('Failed to fetch datasets')
    }
    // Assert the response is JSON
    if (!response.headers.get('content-type')?.includes('application/json')) {
      throw new Error('Invalid content type')
    }

    return await response.json()
  }

  const fetchDatasets = async () => {
    datasets.value = await getDatasets()
    // sort the sites by name
    datasets.value.sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }))
  }

  const datasetKeys = computed(() => {
    return datasets.value.length > 0 ? Object.keys(datasets.value[0]) : []
  })

  return { datasets, fetchDatasets, datasetKeys }
}
